import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppMedlogicPwaCuidadoModule } from './app/app-medlogic-pwa-cuidado.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppMedlogicPwaCuidadoModule)
  .catch((err) => console.error(err));
